<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    :max-width="dialogWidth"
    scrollable
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar>
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ $t('app.buttons.add') }} {{ $t('app.conversion-divisas.single') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            rounded
            color="primary"
            @click="saveItem"
          >
            {{ $t('app.buttons.save') }}
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <validation-observer
          ref="observer"
          v-slot="{ validate, reset }"
        >
          <form>
            <v-list
              three-line
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.conversion-divisas.from_currency') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.conversion-divisas.from_currency')"
                      rules="required"
                    >
                      <v-select
                        v-model="item.from"
                        :placeholder="$t('app.conversion-divisas.from_currency')"
                        :items="divisas"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors"
                        required
                      ></v-select>
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.conversion-divisas.to_currency') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.conversion-divisas.to_currency')"
                      rules="required"
                    >
                      <v-select
                        v-model="item.to"
                        :placeholder="$t('app.conversion-divisas.to_currency')"
                        :items="divisas_excluded"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors"
                        required
                      ></v-select>
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.conversion-divisas.factor') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.conversion-divisas.factor')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="item.factor"
                        :placeholder="$t('app.conversion-divisas.factor')"
                        :error-messages="errors"
                        required
                      />
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ConversionDivisasAdd',
    data () {
      return {
        dialog: false,
        item: {
          from: false,
          to: false,
          factor: null
        },
        datePickerModalStart: false,
        datePickerModalEnd: false,
        divisas: []
      }
    },
    computed: {
      divisas_excluded () {
        return this.divisas.filter(item => item.id != this.item.from)
      }
    },
    mounted () {
      EventBus.$on('conversion-divisas-add', async () => {
        this.toggleLoader()

        this.divisas = await this.getDivisas()

        this.toggleLoader()

        this.dialog = true
      })
    },
    methods: {
      async saveItem () {
        this.$refs.observer.validate()
          .then(async success => {
            if (!success) return

            this.toggleLoader()

            await this.$http.post(route('v1/currency-conversion'), this.item)
              .then(response => {
                if (response.body.code === 200) {
                  this.processSuccess(response)
                  this.item = {
                    from: false,
                    to: false,
                    factor: null
                  }

                  requestAnimationFrame(() => {
                    this.$refs.observer.reset()
                  })

                  this.dialog = false
                  EventBus.$emit('reload-items')
                } else {
                  this.processError(response)
                }
              }, error => {
                this.processError(error)
              })

            this.toggleLoader()
          })
      },
    },
  }
</script>

<style scoped>

</style>
